// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
const _associations = [
];

const _fieldDefs = [
			{
				title: 'hucId',
				placeholder: null,
				key: 'hucId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.hucId,
				setter: (x, y) => x.hucId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'HUC Code',
				placeholder: null,
				key: 'hucCode',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.hucCode,
				setter: (x, y) => x.hucCode = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'basin',
				placeholder: null,
				key: 'basin',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.basin,
				setter: (x, y) => x.basin = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'subBasin',
				placeholder: null,
				key: 'subBasin',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.subBasin,
				setter: (x, y) => x.subBasin = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'watershed',
				placeholder: null,
				key: 'watershed',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.watershed,
				setter: (x, y) => x.watershed = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'subWatershed',
				placeholder: null,
				key: 'subWatershed',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.subWatershed,
				setter: (x, y) => x.subWatershed = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(100),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'name',
				placeholder: null,
				key: 'name',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class Huc extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
